import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { View, Text } from "react-native";
import { Button } from "../../../components/core/Button";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import { globalImport } from "../../../common/globalImports";
import YoutubePlayerReact from "./youtubePlayerReact";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const HowToTradeVideo = ({ onLearnMore, hTTVideoKey, isContest }) => {
  const [playing, setPlaying] = useState(true);

  const onStateChange = useCallback((state) => {
    if (state === "ended") {
      setPlaying(false);
    }
  }, []);

  const togglePlaying = useCallback(() => {
    setPlaying((prev) => !prev);
  }, []);

  return (
    <View style={{ paddingVertical: 25, paddingHorizontal: 15 }}>
      <FormTextLabel
        labelStyles={{
          ...globalFontStyle.appFontTitle,
          color: Colors.black,
          marginBottom: 10,
        }}
        label={!isContest ? "How to trade?" : "How it Works?"}
      />
      {!isContest ? (
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontBody,
            color: Colors.grey,
            marginBottom: 30,
          }}
          label={"Start trading in three simple steps & start earning!"}
        />
      ) : null}
      <View style={{ borderRadius: 30 }}>
        <YoutubePlayerReact
          hTTVideoKey={hTTVideoKey}
          onStateChange={onStateChange}
        />
      </View>

      <Button
        variant="primary"
        size="default"
        onPress={onLearnMore}
        style={{ 
          flex: globalImport.isWeb ? {} : 0,
          marginTop: 20,
          backgroundColor: isContest ? Colors.black : Colors.tradexBlue,
        }}
        className="video-button"
        translate
      >
        {isContest ? "Okay" : "Proceed"}
      </Button>
    </View>
  );
};

export default connect(null, null)(HowToTradeVideo);
